import React, { useMemo, useState } from 'react';
import { UpdatedRequestTable } from '../../../../../../components/table/RequestTable';
import { convertTo12Hour } from '../../../../../../utils/dateTimeFormatter';
import { useNavigate } from 'react-router-dom';
import { clearFlaggedQuestion } from '../../../../../../features/candidate-exam/candidate-exam-slice';
import { useDispatch } from 'react-redux';
import BookexamModal from './BookexamModal';
import UnlockAssessmentModal from './unlockAssessmentModal';
import ViewBookingModal from './ViewBookingModal';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import EmailVerificationModal from '../../../../../account/components/EmailVerificationModal';
import { EyeIcon, PencilSquareIcon } from '@heroicons/react/24/outline';
const PhysicalExams = ({
  exams, isLoading, currentPage, setCurrentPage, perPage, setPerPage,
  refetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = JSON.parse(sessionStorage.getItem('user'))
  const isVerified = sessionStorage.getItem('is_verified')
  const [showNotification, setShowNotification] = useState(false);
  const [requireBooking, setRequireBooking] = useState(false)
  const [openViewBookingModal, setOpenViewBookingModal] = useState(false)
  const [isLocked, setIsLocked] = useState(false)
  const [currentExam, setCurrentExam] = useState(null)

  const handleActionClick = async (row) => {
    // if (!row?.number_of_attempts_allowed || (
    //   row?.number_of_attempts >= row?.number_of_attempts_allowed
    // )) return toast.error(t('attempt-limit-reached'))

    sessionStorage.setItem('active-exam', JSON.stringify(row))
    sessionStorage.setItem('active-pipeline', JSON.stringify(row))
    window.sessionStorage.setItem("active-pipeline-id", row?.exam_id);
    dispatch(clearFlaggedQuestion());
    // exam requires booking and candidate haven't booked 
    if (row?.require_booking && !row?.booked_at) {
      if (parseInt(isVerified) === 0) {
        setShowNotification(true)
      }
      setRequireBooking(true);
      // try {
      //   const response = await createBooking({
      //     userId: window.sessionStorage.getItem("user_id") || JSON.parse(sessionStorage.getItem("user"))?.user?.user_id,
      //     userExamId: row?.user_exam_id,
      //     groupId: row?.group_id,
      //     assessmentId: row?.assessment_id
      //   })
      //   toast.success(response.message)
      // }
      // catch (error) {
      //   toast.error(error?.response?.data?.message);
      // }
    }
    else {
      // exam is already booked
      if (row?.booked_at) {
        // check if exam is lock
        if (parseInt(isVerified) === 0) {
          return setShowNotification(true)
        }
        //  if(!row?.allow_booking_change){
        //    return toast.error('Booking cannot be changed')
        //  }
        if (!row?.otp_locked && !row?.exam_is_locked) {
          return navigate(`/candidate/assessments/candidate-exams/${row?.exam_id}`);
        }
        return setRequireBooking(true)
      }
      else {
        if (row?.otp_locked || row?.exam_is_locked) {
          return toast('Exam is locked')
        }
        navigate(`/candidate/assessments/candidate-exams/${row?.exam_id}`);
      }
    }
  }

  let columns = useMemo(
    () => [
      {
        title: t('id'),
        selector: null,
        key: "id",
        render: ({ index }) =>
          index +
          1 +
          ((exams?.current_page || 1) - 1) *
          (exams?.per_page || perPage),
      },
      {
        title: t('exam-name'),
        selector: "exam_name",
        key: "exam_name",
        render: ({ item, row }) => {
          return (
            <button
              className="text-baseFont underline text-primary"
              onClick={() => handleActionClick(row)}
            >
              {item}
            </button>
          );
        },
      },
      {
        title: 'Exam Type',
        selector: null,
        key: null,
        render: ({ item, row }) => {
          return <span className={`capitalize font-bold ${row?.require_booking ? 'text-darkBlue' : 'text-orange-500'}`}>{`${row?.require_booking ? 'Physical' : 'Online'}`}</span>
        }
      },
      {
        title: t('start-date'),
        selector: "start_date",
        key: "start_date",
        render: ({ item }) => {
          return <span>{`${new Date(item).toLocaleDateString('en-ng')}`}</span>
        }
      },
      {
        title: t('end-date'),
        selector: "end_date",
        key: "end_date",
        render: ({ item }) => {
          return <span>{`${new Date(item).toLocaleDateString('en-ng')}`}</span>
        }
      },
      {
        title: t('start-time'),
        selector: "start_time",
        key: "start_time",
        render: ({ item }) => {
          return <span>{`${convertTo12Hour(item)}`}</span>
        }
      },
      {
        title: t('end-time'),
        selector: "end_time",
        key: "end_time",
        render: ({ item }) => {
          return <span>{`${convertTo12Hour(item)}`}</span>
        }
      },
      {
        title: t('action'),
        selector: "end_time",
        key: "end_time",
        render: ({ item, row }) => {
          if (row?.booked_at && row?.booking_info) {
            return (
              <>
                <button
                  data-test-id={`take-exam-${row?.assessment_id}`}
                  //disabled={row?.exam_is_locked || row?.otp_locked}
                  className={`${(row?.exam_is_locked || row?.otp_locked) && !row?.allow_booking_change ? 'bg-gray-400' : row?.allow_booking_change ? 'bg-darkBlue' : 'bg-primary'} rounded-full text-white py-2 px-2 text-sm`}
                  onClick={() => handleActionClick(row)}
                >
                  {
                    row?.allow_booking_change ?
                      'Update'
                      :
                      row?.exam_is_locked || row?.otp_locked ?
                        'Exam is Locked'
                        : 'View'
                  }
                </button>
                {/* <button
                  onClick={() => {
                    setCurrentExam(row);
                    setOpenViewBookingModal(true);
                  }}
                  className="bg-primary ml-1 rounded-full text-white py-2 px-2 text-sm"
                >
                  View
                </button> */}
              </>
            )
          }
          return <button
            data-test-id={`take-exam-${row?.assessment_id}`}
            disabled={row?.exam_is_locked && !row?.require_booking && !row?.booked_at}
            className={`${(row?.exam_is_locked && !row?.require_booking && !row?.booked_at) || row?.otp_locked ? 'bg-gray-400' : 'bg-primary'} rounded-full text-white py-2 px-5 text-sm`}
            onClick={() => handleActionClick(row)}
          >
            {
              (!row?.require_booking || row?.booked_at) ?
                row?.exam_is_locked || row?.otp_locked ?
                  //t('unlock-exam')
                  'Exam is Locked'
                  : 'View Exams' :
                t('book-exam')
            }
          </button>
        }
      },
    ], [exams?.current_page, exams?.per_page, perPage])

  return (
    <div className='p-3 rounded-lg bg-white'>
      {showNotification && (
        <EmailVerificationModal
          setShowNotification={setShowNotification}
          email={user?.user?.email}
          showSkip={false}
        />
      )}
      {
        openViewBookingModal ?
          <ViewBookingModal exam={currentExam} closeModal={setOpenViewBookingModal} />
          : null
      }
      {requireBooking ?
        <BookexamModal
          closeModal={setRequireBooking}
          refetch={refetch}
        />
        : null
      }
      {
        isLocked ?
          <UnlockAssessmentModal
            refetch={refetch} closeModal={setIsLocked}
          />
          : null
      }
      <div className='max-[500px]:hidden'>
        <UpdatedRequestTable
          columns={columns}
          data={exams}
          isLoading={isLoading}
        />
      </div>
      <div className='md:hidden grid grid-cols-1 gap-5'>
        {
          exams?.length ?
            exams?.map((exam, index) => {
              return (
                <ul key={exam?.exam_id || index} className="border border-gray-200 rounded-lg mb-8 p-0">
                  <li className="flex justify-between py-3 px-4">
                    <span className="text-lg">{t('exam-name')}:&nbsp;</span>
                    <span className="text-lg text-primary underline"
                      onClick={() => handleActionClick(exam)}
                    >
                      {exam?.exam_name}
                    </span>
                  </li>
                  <li className="flex justify-between bg-gray-100 py-4 px-4">
                    <span className="text-lg">Exam Type:&nbsp;</span>
                    <span className={`text-lg ${exam?.require_booking ? 'text-darkBlue' : 'text-orange-500'}`}>{`${exam?.require_booking ? 'Physical' : 'Online'}`}</span>
                  </li>

                  <li className="flex  bg-gray-100 justify-between py-4 px-4">
                    <div className='flex items-center'>
                      <span className="text-lg">{t('start-date')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                        {`${new Date(exam?.start_date).toLocaleDateString('en-ng')}`}
                      </span>
                    </div>
                    <div className='flex items-center'>
                      <span className="text-lg">{t('end-date')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                        {`${new Date(exam?.end_date).toLocaleDateString('en-ng')}`}
                      </span>
                    </div>
                  </li>
                  <li className="flex justify-between py-4 px-4">
                    <div className='flex items-center'>
                      <span className="text-lg">{t('start-time')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                        {`${convertTo12Hour(exam?.start_time)}`}
                      </span>
                    </div>
                    <div className='flex items-center'>
                      <span className="text-lg">{t('end-time')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                        {`${convertTo12Hour(exam?.end_time)}`}
                      </span>
                    </div>
                  </li>
                  <li className="flex justify-between bg-gray-100 py-4 px-4">
                    <span className="text-lg">{t('action')}:&nbsp;</span>
                    <div className="flex gap-2">
                      {exam?.booked_at && exam?.booking_info ? (
                        <>
                          <button
                            data-test-id={`take-exam-${exam?.assessment_id}`}
                            className={`${(exam?.exam_is_locked || exam?.otp_locked) && !exam?.allow_booking_change ? 'bg-gray-400' : exam?.allow_booking_change ? 'bg-darkBlue' : 'bg-primary'} rounded-full text-white py-2 px-4 text-sm`}
                            onClick={() => handleActionClick(exam)}
                          >
                            {exam?.allow_booking_change ? 'Update' : exam?.exam_is_locked || exam?.otp_locked ? 'Exam is Locked' : 'View'}
                          </button>
                          {/* <button
                            onClick={() => {
                              setCurrentExam(exam);
                              setOpenViewBookingModal(true);
                            }}
                            className="bg-primary bi bi-eye rounded-full text-white py-2 px-2 text-sm"
                          >
                            View
                          </button> */}
                        </>
                      ) : (
                        <button
                          data-test-id={`take-exam-${exam?.assessment_id}`}
                          disabled={exam?.exam_is_locked && !exam?.require_booking && !exam?.booked_at}
                          className={`${(exam?.exam_is_locked && !exam?.require_booking && !exam?.booked_at) || exam?.otp_locked ? 'bg-gray-400' : 'bg-primary'} rounded-full text-white py-2 px-5 text-sm`}
                          onClick={() => handleActionClick(exam)}
                        >
                          {(!exam?.require_booking || exam?.booked_at) ? exam?.exam_is_locked || exam?.otp_locked ? 'Exam is Locked' : 'View Exams' : t('book-exam')}
                        </button>
                      )}
                    </div>
                  </li>
                </ul>
              )
            })
            : null
        }
      </div>
    </div>
  )
}

export default PhysicalExams